import React from 'react';
import { cn } from '../../lib/utils';

/**
 * 3×3 position selection grid — used for accent glow placement.
 *
 * @param {Object}   props
 * @param {Array}    props.positions  — Array of { id } objects (9 items for 3×3)
 * @param {string}   props.value      — Currently selected position ID
 * @param {Function} props.onChange    — (positionId: string) => void
 * @param {string}   [props.label]    — Optional inline label (displayed to the left)
 * @param {string}   [props.labelWidth] — Tailwind width for label (default: "w-10")
 */
export function PositionGrid({
  positions,
  value,
  onChange,
  label,
  labelWidth = 'w-10',
}) {
  const grid = (
    <div className="grid grid-cols-3 gap-1 p-1.5 rounded-lg bg-white/[0.03] border border-white/8">
      {positions.map((pos) => (
        <button
          key={pos.id}
          onClick={() => onChange(pos.id)}
          className={cn(
            'w-5 h-5 rounded-md transition-all flex items-center justify-center',
            value === pos.id
              ? 'bg-white/25'
              : 'bg-white/[0.04] hover:bg-white/10'
          )}
        >
          <span
            className={cn(
              'w-2 h-2 rounded-full transition-all',
              value === pos.id
                ? 'bg-white'
                : 'bg-white/25'
            )}
          />
        </button>
      ))}
    </div>
  );

  if (label) {
    return (
      <div className="flex items-center gap-2">
        <span className={`text-[10px] text-white/40 ${labelWidth} shrink-0`}>{label}</span>
        {grid}
      </div>
    );
  }

  return grid;
}
